var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-debug-page"},[_c('h1',[_vm._v("Component Debug Page")]),_c('main',[_c('LocationInput',{attrs:{"interactive":true,"type":_vm.type,"allowCircle":true,"radius":_vm.radius,"coordinates":_vm.coordinates},on:{"update":_vm.updateInput,"updateRadius":_vm.updateRadius}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }